import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Field, Form } from 'react-final-form';
import Select from 'react-select';
import { Col } from 'react-bootstrap';
import {
  Card, CardBody, CardTitleWrap,
} from '@/shared/components/Card';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import renderRadioButtonField from '@/shared/components/form/RadioButton';
import {
  FormButtonToolbar,
  FormContainer,
  FormGroup,
  FormGroupField,
  FormGroupLabel,
  FormHalfContainer,
} from '@/shared/components/form/FormElements';
import { Button } from '@/shared/components/Button';
import PaxDetailsCard from './PaxDetailsCard';
import { AuthContext } from '../../../../../../context/AuthContext';


const AddTrip = ({ onSubmit }) => {
  const { apiGlobal, countryid } = useContext(AuthContext);

  const [agentOption, setAgentOption] = useState([]);

  const fetchAgentOption = async () => {
    const formData = new FormData();
    formData.append('country_id', countryid);
    try {
       const url = await fetch(`${apiGlobal}agent_data.php`, {
        method: 'POST',
        body: formData,
       }); 
       const response = await url.json();
      //  console.log(response);
       if (response.status && response.message === 'Success') {
        const agentOptions = response.data.map(Agent => ({
          value: Agent.id, 
          label: Agent.name,
        }));
        setAgentOption(agentOptions);
       } else {
        console.log('Something went Wrong While Fetching Agent Option');
       }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAgentOption();
  }, []);

  return (

    <Col md={12} lg={12}>
      <Card>
        <CardBody>
          <CardTitleWrap>
            <p><span style={{ color: 'red' }}>*</span> Mark Fields are required.</p>
          </CardTitleWrap>
          <Form onSubmit={onSubmit}>
            {({ handleSubmit }) => (
              <FormContainer onSubmit={handleSubmit}>
                <FormHalfContainer>
                  <div className="col-12 mb-3">
                    <FormGroupLabel>Select Agent<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                    <Field name="selectAgent">
                      {({ input }) => (
                        <Select
                          {...input}
                          name="selectAgent"
                          className="react-select w-100"
                          isClearable={false}
                          placeholder="Select a Agent"
                          options={agentOption}
                          required
                        />
                          )}
                    </Field>
                  </div>
                  <FormGroup>
                    <FormGroupLabel>Trip Name<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                    <FormGroupField>
                      <Field
                        name="tripname"
                        component="input"
                        type="text"
                        placeholder="Trip Name"
                      />
                    </FormGroupField>
                  </FormGroup>
                  <FormGroup
                    className="col-md-12"
                    style={{
                    display: 'flex',
                  }}
                  >
                    <div className="col-md-6">
                      <FormGroupLabel>
                        Start Date <span style={{ color: 'red' }}>*</span>
                      </FormGroupLabel>
                      <FormGroupField>
                        <div>
                          <Field name="startDate">
                            {({ input }) => (
                              <DatePicker
                                {...input}
                                selected={input.value || null} // Ensure null if no date is selected
                                onChange={date => input.onChange(date)} // Update form value on date change
                                minDate={new Date(new Date().setDate(new Date().getDate() + 1))}
                                dateFormat="dd-MM-yyyy"
                                placeholderText="Select Start Date"
                              />
            )}
                          </Field>
                        </div>
                      </FormGroupField>
                    </div>
                    <div className="col-md-6">
                      <FormGroupLabel>
                        End Date <span style={{ color: 'red' }}>*</span>
                      </FormGroupLabel>
                      <FormGroupField>
                        <div>
                          <Field name="endDate">
                            {({ input }) => (
                              <DatePicker
                                {...input}
                                selected={input.value || null} // Ensure null if no date is selected
                                onChange={date => input.onChange(date)} // Update form value on date change
                                dateFormat="dd-MM-yyyy"
                                minDate={new Date(new Date().setDate(new Date().getDate() + 1))} // today + 1
                                placeholderText="Select End Date"
                              />
            )}
                          </Field>
                        </div>
                      </FormGroupField>
                    </div>
                       
                  </FormGroup>

                  <FormGroup>
                    <FormGroupLabel>Trip Type<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                    <FormGroupField>
                      <Field
                        name="triptype"
                        component={renderRadioButtonField}
                        label="Group"
                        radioValue="1"
                      />
                      <Field
                        name="triptype"
                        component={renderRadioButtonField}
                        label="Family"
                        radioValue="2"
                      />
                    </FormGroupField>
                  </FormGroup>
                </FormHalfContainer>
                <FormHalfContainer>
                  <h4>
                    Pax Details
                  </h4>
                  <PaxDetailsCard />
                </FormHalfContainer>
            
                <FormButtonToolbar>
                  <Button variant="primary" type="submit">Add Trip</Button>
                </FormButtonToolbar>
              </FormContainer>
        )}
          </Form>
        </CardBody>
      </Card>
    </Col>
      
    );
};

AddTrip.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default React.memo(AddTrip);
